import { atom, useSetAtom } from 'jotai';
import { useEffect } from 'react';

/**
 * How many full-width strips are showing above the navigation row. The rail is
 * pinned to the viewport's top edge by default, so while any strip shows it
 * has to anchor to the page shell instead, or it paints over the strip.
 */
export const topStripCountAtom = atom(0);

/** Tells the layout a strip above the navigation row is on screen. */
export const useReportTopStrip = (isShowing: boolean): void => {
  const setCount = useSetAtom(topStripCountAtom);

  useEffect(() => {
    if (!isShowing) return;
    setCount((count) => count + 1);
    return () => {
      setCount((count) => count - 1);
    };
  }, [isShowing, setCount]);
};
